<template>
	<div>
		<v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
		<div v-else-if="profileSection">
			<UserInfo
				@toggleToPublicInfo="toggleToPublicInfo"
				:isPublicButton="true"
				:userInfo="profileSection.personalInformation"
			/>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import UserInfo from '@/components/User/UserInfo.vue'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'PersonalProfileInfo',
	mixins: [Dwh],
	components: { UserInfo },
	data() {
		return {
			attrs: {
				elevation: 0,
			},
		}
	},
	methods: {
		...mapActions('app', ['setPageTitle']),
		...mapActions('auth', ['getProfileSection', 'clearProfileSection']),
		dwhViewPersonalInfo() {
			this.sendTrigger({
				category: 'Profile',
				action: 'view_personal_info',
				module: 'My Account',
				title: 'Personal Information',
				id1: this.currentUser.user_id,
			})
		},
		dwhClickViewPublicProfile() {
			this.sendTrigger({
				category: 'Profile',
				action: 'click_view_public_profile',
				module: 'My Account',
				title: this.currentUser.visible_username,
				id1: this.currentUser.user_id,
			})
		},
		toggleToPublicInfo() {
			this.dwhClickViewPublicProfile()
			return this.$router.push({
				name: 'public-information',
			})
		},
	},
	computed: {
		...mapGetters('auth', [
			'profileSection',
			'profileSectionLoading',
			'profileSectionError',
			'profile',
		]),
		currentUser() {
			return this.profile
		},
	},
	mounted() {
		this.dwhViewPersonalInfo()
		this.setPageTitle('Personal Information')
	},
	created() {
		this.getProfileSection('personalInformation')
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearProfileSection()
	},
}
</script>

<style lang="scss"></style>
